import React from 'react';
import { CgLogIn } from 'react-icons/cg';

export const DropdownLoginItems = [
    {
        title: 'Hooklab Monitoramento',
        path: 'https://monitoramento.hooklab.com.br/app/login',
        className: 'dropdown-link',
        icon: <CgLogIn />
    },
    {
        title: 'Monitoramento Netshoes',
        path: 'https://hooklab.com.br/pt-br/login',
        className: 'dropdown-link',
        icon: <CgLogIn />
    }
];